import * as React from "react";
import {
    DataGridPro,
    GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import { AccExecClientResponse } from "../../../../services/types/clientTypes";


export interface AccountManagerSubDataGridProProps {
    accountCELists: AccExecClientResponse[] | undefined;
    isLoading: boolean;
}

export const AccountManagerSubDataGridPro: React.FC<AccountManagerSubDataGridProProps> = (
    props
) => { 
    const COLUMNS = [
        {
            field: "fiscalYear",
            headerName: "Fiscal Year",
            type: "string",
            width: 100,      
        },  
        {
            field: "parentKey",
            headerName: "Parent Key",
            type: "string",
            width: 100,
        },
        {
            field: "parentName",
            headerName: "Client Name",
            type: "string",
            width: 100,
        }, 
        {
            field: "accountOwnerName",
            headerName: "Account Owner Name",
            type: "string",
            width: 150,
        },
        {
            field: "newClientIndicator",
            headerName: "Secondary Mapping",
            valueGetter: (params: any) => Boolean(params.row.newClientIndicator),
            type: "boolean",
            renderCell: (params: GridRenderCellParams) => (params.value ? "Yes" : "No"),
            width: 150,
        },
        {
            field: "effectiveStartDate",
            headerName: "Effective Start Date",
            valueGetter: (params: any) => new Date(params.row.effectiveStartDate),
            type: "date",
            renderCell: (params: GridRenderCellParams) => (
                <span>
                    {params.value
                        .toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                        })
                        .replace(/\//g, "-")}
                </span>
            ),
            width: 150,
        },
        {
            field: "effectiveEndDate",
            headerName: "Effective End Date",
            valueGetter: (params: any) => new Date(params.row.effectiveEndDate),
            type: "date",
            renderCell: (params: GridRenderCellParams) => (
                <span>
                    {params.value
                        .toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric",
                        })
                        .replace(/\//g, "-")}
                </span>
            ),
            width: 150,
        },
    ];
    return (        
        <DataGridPro
            getRowId={(row) => row.mapperID}
            rows={props.accountCELists == null ? [] : props.accountCELists}
            columns={COLUMNS}
            loading={props.isLoading}
            hideFooter
            hideFooterPagination
            hideFooterRowCount
            disableMultipleSelection
            disableSelectionOnClick
            autoHeight
            initialState={{
                sorting: {
                    sortModel: [{ field: "mapperID", sort: "asc" }],
                },
            }}
        />       
    );
};

export default AccountManagerSubDataGridPro;
